import { render, staticRenderFns } from "./AllSalaryReports.vue?vue&type=template&id=c028066c&scoped=true"
import script from "./AllSalaryReports.vue?vue&type=script&lang=js"
export * from "./AllSalaryReports.vue?vue&type=script&lang=js"
import style0 from "./AllSalaryReports.vue?vue&type=style&index=0&id=c028066c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c028066c",
  null
  
)

export default component.exports